export const selectCourseStackNavigatorState = (state) =>
  state.navCourseTabStack;
